import { render, staticRenderFns } from "./TgListCardGroup.vue?vue&type=template&id=3343206e"
import script from "./TgListCardGroup.vue?vue&type=script&lang=js"
export * from "./TgListCardGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports